"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var v2_exports = {};
__export(v2_exports, {
  changeIdentity: () => changeIdentity,
  checkPasswordToken: () => checkPasswordToken,
  checkSigninEmail: () => checkSigninEmail,
  forgotPassword: () => forgotPassword,
  listWorkspaceAccess: () => listWorkspaceAccess,
  readAttempt: () => readAttempt,
  readOption: () => readOption,
  readOrFail: () => readOrFail,
  readWorkspaceAccess: () => readWorkspaceAccess,
  resetPassword: () => resetPassword,
  sendWelcomeEmail: () => sendWelcomeEmail,
  signin: () => signin
});
module.exports = __toCommonJS(v2_exports);
var import_fp = require("@cartographerio/fp");
var import_io = require("@cartographerio/io");
var import_types = require("@cartographerio/types");
var fetch = __toESM(require("../../fetch.js"));
var import_response = require("../../response.js");
const basePath = "/auth/v2";
function signin(apiConfig, body) {
  const url = { path: `${basePath}/login` };
  return fetch.post({ apiParams: { apiConfig }, url, body }).flatMap(import_response.readAsJson).map(
    (0, import_response.recoverUnknownErrors)({
      400: import_types.isSigninResponse,
      401: import_types.isSigninResponse,
      403: import_types.isSigninResponse,
      404: import_types.isSigninResponse
    })
  ).map(import_response.validationErrorsToChecked).flatMap((0, import_response.contentAs)("Checked<SigninResponse>", (0, import_types.isChecked)(import_types.isSigninResponse))).map(import_types.checkedToResult);
}
function readOrFail(apiConfig, token) {
  return fetch.get({ apiParams: { apiConfig }, url: { path: `${basePath}/${token}` } }).flatMap(import_response.readAsJson).flatMap((0, import_response.contentAs)("Credentials", import_types.isCredentials)).partialRecover(import_types.isNotFoundError, (error) => import_io.IO.fail((0, import_types.expiredAuthorizationError)(error.timestamp ?? void 0)));
}
function readOption(apiConfig, token) {
  return fetch.get({ apiParams: { apiConfig }, url: { path: `${basePath}/${token}` } }).flatMap(import_response.readAsJson).flatMap((0, import_response.optionalContentAs)("Credentials", import_types.isCredentials));
}
function readAttempt(apiConfig, token) {
  return readOption(apiConfig, token).map((option) => option.toSuccess(() => (0, import_types.expiredAuthorizationError)((0, import_types.nowTimestamp)()))).partialRecover(import_types.isAuthError, (error) => import_fp.Result.fail(error));
}
function forgotPassword(apiConfig, request) {
  return fetch.post({
    apiParams: { apiConfig },
    url: { path: `${basePath}/forgot-password` },
    body: request
  }).void();
}
function checkSigninEmail(apiConfig, email) {
  return fetch.get({
    apiParams: { apiConfig },
    url: { path: `${basePath}/check-signin-email/${email}` }
  }).flatMap(import_response.readAsJson).flatMap((0, import_response.contentAs)("CheckSigninEmailResponse", import_types.isCheckSigninEmailResponse));
}
function listWorkspaceAccess(apiParams) {
  return fetch.get({
    apiParams,
    url: { path: `${basePath}/check-workspace-access` }
  }).flatMap(import_response.readAsJson).flatMap((0, import_response.contentAs)("SearchResults<CheckWorkspaceAccessResult>", (0, import_types.isSearchResults)(import_types.isCheckWorkspaceAccessResult)));
}
function readWorkspaceAccess(apiParams, workspace) {
  return fetch.get({
    apiParams,
    url: { path: `${basePath}/check-workspace-access/${workspace}` }
  }).flatMap(import_response.readAsJson).flatMap((0, import_response.contentAs)("CheckWorkspaceAccessResult", import_types.isCheckWorkspaceAccessResult));
}
function checkPasswordToken(apiConfig, token) {
  return fetch.get({
    apiParams: { apiConfig },
    url: { path: `${basePath}/check-password-token/${token}` }
  }).flatMap(import_response.readAsJson).flatMap((0, import_response.contentAs)("CheckResetPasswordTokenResponse", import_types.isCheckResetPasswordTokenResponse));
}
function resetPassword(apiConfig, request) {
  return fetch.post({
    apiParams: { apiConfig },
    url: { path: `${basePath}/reset-password` },
    body: request
  }).flatMap(import_response.readAsJson).flatMap((0, import_response.contentAs)("ResetPasswordResult", import_types.isResetPasswordResult));
}
function changeIdentity(apiParams, userId) {
  return fetch.post({
    apiParams,
    url: { path: `${basePath}/change-identity` },
    body: { userId }
  }).flatMap(import_response.readAsJson).flatMap((0, import_response.contentAs)("SigninResponse", import_types.isSigninResponse));
}
function sendWelcomeEmail(apiParams, email, workspace) {
  return fetch.post({
    apiParams,
    url: { path: `${basePath}/welcome-email` },
    body: { workspace, email }
  }).void();
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  changeIdentity,
  checkPasswordToken,
  checkSigninEmail,
  forgotPassword,
  listWorkspaceAccess,
  readAttempt,
  readOption,
  readOrFail,
  readWorkspaceAccess,
  resetPassword,
  sendWelcomeEmail,
  signin
});
//# sourceMappingURL=v2.js.map
